import { ProyectoTareasEstado } from 'src/utils/enums/ProyectoTareasEstado';
import { ProyectoTareasFormState } from './types';

import {} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ProyectoTareasFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'proyectoTareasForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusPlanificada(state) {
      state.status = {
        id: ProyectoTareasEstado.Planificada,
        text: ProyectoTareasEstado[
          ProyectoTareasEstado.Planificada
        ].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusEnProceso(state) {
      state.status = {
        id: ProyectoTareasEstado.EnProceso,
        text: ProyectoTareasEstado[
          ProyectoTareasEstado.EnProceso
        ].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusRealizada(state) {
      state.status = {
        id: ProyectoTareasEstado.Realizada,
        text: ProyectoTareasEstado[
          ProyectoTareasEstado.Realizada
        ].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
    setFormStatusAnulada(state) {
      state.status = {
        id: ProyectoTareasEstado.Anulada,
        text: ProyectoTareasEstado[ProyectoTareasEstado.Anulada].toUpperCase(),
        color: '#70BDFF',
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
      };
    },
  },
  extraReducers: (builder) => {},
});
// Selectors

export const selectFormStatus = (state: RootState) =>
  state.proyectoTareas.form.status;

export const selectGuardar = (state: RootState) =>
  state.proyectoTareas.form.actions?.guardar;

// Export actions
export const {
  resetForm,

  setFormStatusPlanificada,
  setFormStatusEnProceso,
  setFormStatusRealizada,
  setFormStatusAnulada,
} = formSlice.actions;

export default formSlice.reducer;
